import { createContext, Dispatch, SetStateAction } from 'react';
import * as CC from '@blisspointmedia/bpm-types/dist/CrossChannelPerformance';
import { CompanyFiscalCal } from '@blisspointmedia/bpm-types/dist/FiscalCalendar';
import { FilterPaneState } from '@blisspointmedia/bpm-types/dist/FilterPane';
import { MetricsPagePreset } from '@blisspointmedia/bpm-types/dist/MetricsPage';
import { PresetIDGroups as SimpleMetricsTablePreset } from '@blisspointmedia/bpm-types/dist/MetricsTable';
import { DateRange } from '@src/utils/date-utils';

interface CrossChannelContextType {
  company: string;
  dates: DateRange;
  otherDates: DateRange;
  selectedChannels: Record<string, boolean>;
  deliveryAndPerformanceChannels: Record<string, boolean>;
  channelColors: Record<string, string>;
  kpi: string;
  crossChannelKPIs: string[];
  platformAsSourceOfData: boolean;
  selectedSources: string[];
  // URL
  setURL: (pagePresetName: string, tablePresetName?: string) => void;
  // Page Preset
  pagePreset?: MetricsPagePreset;
  // Filter Preset
  filterData?: CC.GetFilterOptionsResponse;
  filterID?: number;
  filterSource?: 'presetFilterID' | 'currentFilterID' | 'presetState' | 'currentState';
  filterState?: FilterPaneState;
  setFilterData: Dispatch<SetStateAction<CC.GetFilterOptionsResponse | undefined>>;
  // Table Preset
  fetchingTablePresets: boolean;
  getTablePresets: () => void;
  setFetchingTablePresets: Dispatch<SetStateAction<boolean>>;
  tablePresetName?: string;
  tablePresets?: SimpleMetricsTablePreset[];
  // Metrics Table
  metricsTableDataMap: Record<string, any>;
  setMetricsTableDataMap: Dispatch<SetStateAction<Record<string, any>>>;
  metricsTableDataKey: string;
  metricsTableDataOtherKey: string;
  customSegments: Record<string, boolean>;
  dataInfo: Record<string, string>[];
  fiscalCal: CompanyFiscalCal;
  usedGroupedSegments?: Record<string, string[]>;
}

export const CrossChannelContext = createContext<CrossChannelContextType>({
  company: '',
  dates: { start: '', end: '' },
  otherDates: { start: '', end: '' },
  selectedChannels: {},
  deliveryAndPerformanceChannels: {},
  channelColors: {},
  kpi: '',
  crossChannelKPIs: [],
  platformAsSourceOfData: false,
  selectedSources: [],
  // Metrics Table
  metricsTableDataMap: {},
  setMetricsTableDataMap: () => {},
  metricsTableDataKey: '',
  metricsTableDataOtherKey: '',
  // Table Preset
  fetchingTablePresets: false,
  getTablePresets: () => {},
  setFetchingTablePresets: () => {},
  // Filters
  setFilterData: () => {},
  // URL
  setURL: () => {},
  customSegments: {},
  dataInfo: [],
  fiscalCal: {},
  usedGroupedSegments: {}
});
